module.exports = __webpack_public_path__ + "media/assets/images/shopping/tag-8ed903e7fb93f854f7fc4c8a1cefddd1.svg";